export default "__VITE_ASSET__DV6GxJ6b__"